import { render, staticRenderFns } from "./AcuerdosClientesBasePage.vue?vue&type=template&id=500ee583"
import script from "./AcuerdosClientesBasePage.vue?vue&type=script&lang=js"
export * from "./AcuerdosClientesBasePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports